/**
 * Mirrors the backend's isStudentBypassActiveForTerm (school-api
 * src/services/AuthService/CheckStudentLoginPayment.ts) so the dashboard's
 * "is this student currently exempt" checks agree with what the CBT login
 * gate actually enforces. Keep the two in lockstep if either changes.
 */
export const isBypassActive = (bypass, currentTerm, currentSession) => {
  if (!bypass) return false;
  if (typeof bypass === "boolean") return bypass;
  if (bypass.enabled === false) return false;
  const matchesTerm =
    bypass.term === undefined || bypass.term === null || bypass.term === Number(currentTerm);
  const matchesSession = !bypass.session || bypass.session === currentSession;
  return matchesTerm && matchesSession;
};
